<template>
  <component
    :is="componentTag"
    class="dasarttcsl"
    v-bind="{
      ...(componentTag === 'router-link'
        ? item.routerLinkProps
        : componentTag === 'a'
          ? {
              href: item.url,
              target: '_blank',
            }
          : {}),
    }"
  >
    <div class="dasarttcsl_left">
      <slot name="left">
        <img
          class="dasarttcsl_left_img"
          :src="item.thumbnail_url"
          :style="`opacity: ${imgLoaded ? 1 : 0}`"
          @load="imgLoaded = true"
        />
      </slot>
    </div>
    <div class="dasarttcsl_right">
      <div
        :title="item.title"
        class="text-underline_hover dasarttcsl_right_title"
      >
        {{ item.title }}
      </div>

      <div
        v-if="item.description"
        class="dasarttcsl_right_text"
      >
        <slot
          name="description"
          :item="item"
        >
          {{ item.description }}
        </slot>
      </div>

      <slot name="under_description"> </slot>

      <div class="dasarttcsl_right_bottom">
        <slot name="before_tags"> </slot>
        <slot name="content_tags">
          <!-- <div
            class="dasarttcsl_right_bottom_tags"
            v-if="item.tags"
          >
            <span
              class="dasarttcsl_right_bottom_tags_tag"
              v-for="tag in item.tags || []"
              :style="`background:${tag.color_hex || tag.color || ''}`"
              :key="tag.id"
            >
              {{ tag.name }}
            </span>
          </div> -->
        </slot>
        <slot name="after_tags"> </slot>
      </div>
    </div>
  </component>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'DashboardArticle',
  mixins: [float_mix, format_mix],
  props: {
    componentTag: { default: () => 'a' },
    item: {
      default: () => ({}),
    },
  },
  data() {
    return {
      imgLoaded: false,
    }
  },
}
</script>
<style lang="scss">
.dasarttcsl {
  --height: 19rem;
  --clr-back: var(--clr-black-1);
  // --height: 280px;
  --padding-top-bottom: 2rem;
  --padding-side: 0;
  --gap: 2rem;
  --line-clamp-title: 2;
  --line-clamp: 5;
  --description-font-size: 0.875rem;
  --description-margin: 0.5rem 0 1rem 0;
  --title-font-size: 1.5rem;
  --title-line-height: 1.5;
  --title-overflow: hidden;
  --text-overflow: hidden;
  --left-overflow: hidden;
  --left-background: linear-gradient(-223deg, var(--clr-black-0), var(--clr-black-0-3));
  padding: var(--padding-top-bottom) var(--padding-side);
  // padding: var(--padding-top-bottom) 1rem;
  height: var(--height);
  flex-shrink: 0;
  gap: var(--gap);
  z-index: 2;

  display: flex;
  position: relative;
  flex-shrink: 0;
  width: 100%;
  background: var(--clr-back);
  &_readonly {
    .dasarttcsl_left,
    .dasarttcsl_right_title {
      pointer-events: none;
    }
  }
  &_reversed {
    flex-direction: row-reverse;
  }
  &_left {
    background: var(--left-background);
    border-radius: 1rem;

    aspect-ratio: 16 / 9;
    max-height: calc(var(--height) - calc(var(--padding-top-bottom) * 2));
    // safari ignores padding with aspect-ratio

    flex-shrink: 0;
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    overflow: var(--left-overflow);
    transition: 0.22s;
    &:hover {
      filter: brightness(1.125);
    }
    &_img {
      transition: 0.22s;
      position: absolute;
      width: 100%;
      border-radius: 1rem;
      margin: auto;
    }
  }
  &_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    &_title {
      font-size: var(--title-font-size);
      line-height: var(--title-line-height);
      font-weight: 700;
      color: var(--clr-white-0);
      display: -webkit-box;
      -webkit-line-clamp: var(--line-clamp-title);
      -webkit-box-orient: vertical;
      overflow: var(--title-overflow);
    }
    &_text {
      margin: var(--description-margin);
      font-size: var(--description-font-size);
      font-weight: 400;
      color: var(--clr-grey-2);

      display: -webkit-box;
      -webkit-line-clamp: var(--line-clamp);
      -webkit-box-orient: vertical;
      overflow: var(--text-overflow);
    }
    &_bottom {
      margin: auto 0 0 0;
      display: flex;
      gap: 1rem;
      &_tags {
        --line-clamp: 2;
        gap: 0.25rem;
        display: -webkit-box;
        -webkit-line-clamp: var(--line-clamp);
        -webkit-box-orient: vertical;
        overflow: hidden;
        &_tag {
          margin: 0 0.25rem 0 0;
          font-size: 0.8rem;
          text-shadow: var(--text-shadow_drop);
          font-weight: 600;
          border-radius: 4px;
          padding: 0.125rem 0.5rem;
        }
      }
      &_date {
        margin: auto 0 0 auto;
        font-size: 0.8rem;
        font-weight: 500;
        color: var(--clr-black-6);
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .dasarttcsl {
    --height: 18rem;
    --line-clamp: 3;
  }
}
@media screen and (max-width: 620px) {
  .dasarttcsl {
    --gap: 1rem;
    --line-clamp: 3;
    flex-direction: column;
    height: unset;
    &_left {
      &_img {
      }
    }
    &_right {
      &_title {
      }
      &_text {
      }
      &_bottom {
        &_tags {
          &_tag {
          }
        }
        &_date {
        }
      }
    }
  }
}
</style>
